// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__GvXkV","left":"InfoRow_left__pXWs0"};